import React, {useState, useEffect, useContext} from 'react';
import {Statistic, Row, Col, Card} from 'antd';
import {GlobalContext} from "../context/globalContext";
import {getMethod} from '../services/methods';
import "react-datepicker/dist/react-datepicker.css";
import CompletedReport from "../components/completed-report";

export default function Dashboard() {
    const {contextData} = useContext(GlobalContext);
    const [data, setData] = useState(null);

    async function fetchData() {
        const dashboardData = await getMethod("/dashboard");
        setData(dashboardData)
    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <div key={!data ? "null-state" : data.length}>
            <div>Merhaba, <strong
                style={{textTransform: "capitalize"}}>{contextData?.userData?.name} {contextData?.userData?.surname}</strong>
            </div>
        </div>
    )
}
